angular.module('rental')
    .component('rentalAgreementItems', {
        bindings: {
            agreementId: '<',
            type: '<'
        },
        templateUrl: 'app/rental/agreement-item/rental-agreement-items.html',
        controller: function ($scope, $state, modals, toastr, $rootScope, RentalAgreementConst, RentalAgreement, RentalAgreementService) {
            this.RentalAgreementService = RentalAgreementService

            this.$onChanges = () => {
                this.itemsPromise = RentalAgreement.items({id: this.agreementId, type: this.type}).$promise.then(result => this.items = result)
            }

            this.addItem = () => {
                let data = {
                    item: {
                        type: this.type,
                    },
                    agreementId: this.agreementId
                }
                return modals.open('app/rental/agreement-item/edit-modal.html', 'RentalAgreementItemDialogController', data, {size: 'sm'}, "$ctrl")
            }
            this.editItem = (item, index) => {
                let data = {
                    item: angular.copy(item),
                    agreementId: this.agreementId
                }
                return modals.open('app/rental/agreement-item/edit-modal.html', 'RentalAgreementItemDialogController', data, {size: 'sm'}, "$ctrl")
            }
            this.deleteItem = (item, index) => {
                return modals.confirmDelete("wybrany rekord", () => RentalAgreement.itemDelete({id: this.agreementId, itemId: item.id}).$promise
                    .then(() => {
                        $rootScope.$broadcast(RentalAgreementConst.eventUpdate)
                        toastr.success("Usunięto")
                    })
                )
            }
            this.indexationItem = (item, index) => {
                let data = {
                    item: angular.copy(item),
                    agreementId: this.agreementId
                }
                return modals.open('app/rental/agreement-item/indexation-modal.html', 'RentalAgreementItemIndexationController', data, {size: 'lg'}, "$ctrl")
            }
            this.closeItem = (item, index) => {
                let data = {
                    item: angular.copy(item),
                    agreementId: this.agreementId
                }
                return modals.open('app/rental/agreement-item/close-modal.html', 'RentalAgreementItemCloseController', data, {size: 'sm'}, "$ctrl")
            }

            this.isBeforeNow = (date) => {
                return moment(date).isBefore(moment())
            }
            $scope.$on(RentalAgreementConst.eventUpdate, () => this.$onChanges())
        }
    })
    .controller('RentalAgreementItemDialogController', function ($rootScope, $uibModalInstance, data, toastr, RentalAgreement, RentalAgreementService, RentalAgreementConst) {
        this.RentalAgreementService = RentalAgreementService
        this.$onInit = () => {
            this.item = angular.copy(data.item)
            this.agreementId = angular.copy(data.agreementId)
        }
        this.onIndexationChanged = () => {
            if (this.item.indexation === false) {
                delete this.item.nextIndexationDate
                delete this.item.nextIndexationDescription
            }
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            let promise
            if (this.item.id != null) {
                promise = RentalAgreement.itemUpdate({id: this.agreementId, itemId: this.item.id}, this.item).$promise
            } else {
                promise = RentalAgreement.itemSave({id: this.agreementId}, this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast(RentalAgreementConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
    .controller('RentalAgreementItemIndexationController', function ($rootScope, $uibModalInstance, data, RentalAgreement, RentalAgreementService, RentalAgreementConst) {
        this.RentalAgreementService = RentalAgreementService
        this.$onInit = () => {
            this.agreementId = angular.copy(data.agreementId)
            this.archived = angular.copy(data.item)

            let itemForm = angular.copy(data.item);
            delete itemForm.nextIndexationDate
            delete itemForm.pricePerOne
            delete itemForm.priceTotal
            delete itemForm.startDate
            delete itemForm.endDate
            this.item = {
                amount: itemForm.amount,
                indexation: itemForm.indexation,
                nextIndexationDescription: itemForm.nextIndexationDescription,
            }
        }
        this.onIndexationChanged = () => {
            if (this.item.indexation === false) {
                delete this.item.nextIndexationDate
                delete this.item.nextIndexationDescription
            }
        }
        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            return RentalAgreement.itemIndexation({id: this.agreementId, itemId: this.archived.id}, this.item).$promise
                .then(result => {
                    $rootScope.$broadcast(RentalAgreementConst.eventUpdate)
                    $uibModalInstance.close(result)
                    toastr.success("Zapisano")
                })
        }
    })
    .controller('RentalAgreementItemCloseController', function ($rootScope, $uibModalInstance, data, RentalAgreement, RentalAgreementService, RentalAgreementConst) {
        this.RentalAgreementService = RentalAgreementService
        this.$onInit = () => {
            this.agreementId = angular.copy(data.agreementId)
            this.current = angular.copy(data.item)
            this.item = {
                id: this.current.id,
                agreementStartDate: this.current.agreementStartDate,
                agreementEndDate: this.current.agreementEndDate,
                startDate: this.current.startDate,
                endDate: this.current.endDate,
            }
        }

        this.cancel = () => $uibModalInstance.dismiss()
        this.save = () => {
            return RentalAgreement.itemClose({id: this.agreementId, itemId: this.item.id}, this.item).$promise
                .then(result => {
                    $rootScope.$broadcast(RentalAgreementConst.eventUpdate)
                    $uibModalInstance.close(result)
                    toastr.success("Zapisano")
                })
        }
    })
